import React from 'react';
import {
  storyboardStructuredData,
  breadcrumbStructuredData,
} from 'Utils/content/structured-data';
import StructuredData from './';

const StoryboardStructuredData = (props) => (
  <React.Fragment>
    <StructuredData getData={breadcrumbStructuredData} {...props} />
    <StructuredData getData={storyboardStructuredData} {...props} />
  </React.Fragment>
);

export default StoryboardStructuredData;
